import { render, staticRenderFns } from "./MagazineNav.vue?vue&type=template&id=114a54ef&scoped=true&"
import script from "./MagazineNav.vue?vue&type=script&lang=js&"
export * from "./MagazineNav.vue?vue&type=script&lang=js&"
import style0 from "./MagazineNav.vue?vue&type=style&index=0&lang=css&"
import style1 from "./MagazineNav.vue?vue&type=style&index=1&lang=less&"
import style2 from "./MagazineNav.vue?vue&type=style&index=2&id=114a54ef&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "114a54ef",
  null
  
)

export default component.exports